// extracted by mini-css-extract-plugin
export var childrenContainer = "_b6-0";